import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { customStyles } from "../../design/selectStyle";
import DateRange from "../global/DateRange";
import DatePicker from "react-datepicker";

const ReportFilters = ({
  dateRange,
  onDateChange,
  businessUnits,
  selectedBusinessUnit,
  onBusinessUnitChange,
  purchaseUnitOptions = [],
  selectedPurchaseUnits = [],
  onPurchaseUnitsChange,
  onGenerate,
  loading,
  reportConfig,
  limit,
  onLimitChange,
}) => {
  const { t } = useTranslation("translations");
  const usesPeriod = reportConfig?.usesPeriod;
  const hasPurchaseUnit = reportConfig?.hasPurchaseUnit;

  return (
    <div className="reports__filters">
      <div className="reports__filters-row">
        <div className="reports__filters-field">
          <label className="reports__filters-label">
            {usesPeriod ? t("reports.filters.periodMonth") : t("reports.filters.dateRange")}
          </label>
          {usesPeriod ? (
            <DatePicker
              selected={dateRange.fromDate ? new Date(dateRange.fromDate) : new Date()}
              onChange={(date) =>
                onDateChange({ fromDate: date, toDate: date })
              }
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="reports__filters-input"
            />
          ) : (
            <DateRange
              fromDate={dateRange.fromDate}
              toDate={dateRange.toDate}
              onChange={([from, to]) =>
                onDateChange({ fromDate: from, toDate: to })
              }
              position="right"
            />
          )}
        </div>

        {businessUnits?.length > 0 && reportConfig?.category !== "Purchases" && (
          <div className="reports__filters-field reports__filters-field--bu">
            <label className="reports__filters-label">{t("reports.businessUnit")}</label>
            <Select
              options={businessUnits}
              value={businessUnits.find((bu) => bu.value === selectedBusinessUnit) || businessUnits[0]}
              onChange={(option) => onBusinessUnitChange(option?.value || null)}
              styles={customStyles}
              placeholder={t("common.all")}
              isClearable
            />
          </div>
        )}

        {hasPurchaseUnit && purchaseUnitOptions?.length > 0 && (
          <div className="reports__filters-field reports__filters-field--bu">
            <label className="reports__filters-label">{t("purchases.purchaseUnit")}</label>
            <Select
              isMulti
              options={purchaseUnitOptions}
              value={purchaseUnitOptions.filter((opt) =>
                selectedPurchaseUnits?.includes(opt.value)
              )}
              onChange={(opts) =>
                onPurchaseUnitsChange((opts || []).map((o) => o.value))
              }
              styles={customStyles}
              placeholder={t("common.all")}
              isClearable
            />
          </div>
        )}

        {reportConfig?.hasLimit && (
          <div className="reports__filters-field reports__filters-field--small">
            <label className="reports__filters-label">{t("reports.limit")}</label>
            <input
              type="number"
              className="reports__filters-input"
              value={limit}
              onChange={(e) => onLimitChange(parseInt(e.target.value) || 10)}
              min={1}
              max={100}
            />
          </div>
        )}

        <div className="reports__filters-field reports__filters-field--action">
          <button
            className="reports__filters-btn"
            onClick={onGenerate}
            disabled={loading}
          >
            {loading ? t("reports.filters.loading") : t("reports.generate")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportFilters;
